export default __webpack_public_path__ + "static/media/room-7.d2c011f0.jpg";